import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M12 7v14","key":"svg-1"}],["path",{"d":"M9 21h6","key":"svg-2"}],["path",{"d":"M7.757 9.243a6 6 0 0 0 8.486 0","key":"svg-3"}]]

const IconClothesRack = createReactComponent('outline', 'clothes-rack', 'ClothesRack', __iconNode);

export default IconClothesRack;